import { createApi } from "@reduxjs/toolkit/query/react";
import { appBaseQuery } from "../../services/baseQuery";
import { buildPagedListUrl } from "../../services/queryParams";

export const roleApi = createApi({
  reducerPath: "roleApi",
  baseQuery: appBaseQuery,
  tagTypes: ["Role"],
  endpoints: (builder) => ({
    getRoles: builder.query({
      query: (params = {}) => buildPagedListUrl("role/", params),
      providesTags: ["Role"],
    }),
    addRole: builder.mutation({
      query: (newRole) => ({
        url: "role/",
        method: "POST",
        body: newRole,
      }),
      invalidatesTags: ["Role"],
    }),
    updateRole: builder.mutation({
      query: ({ uid, ...updatedRole }) => ({
        url: `role/${uid}`,
        method: "PUT",
        body: updatedRole,
      }),
      invalidatesTags: ["Role"],
    }),
    deleteRole: builder.mutation({
      query: (uid) => ({
        url: `role/${uid}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Role"],
    }),
  }),
});

export const {
  useGetRolesQuery,
  useAddRoleMutation,
  useUpdateRoleMutation,
  useDeleteRoleMutation,
} = roleApi;
